import { combineReducers, configureStore } from '@reduxjs/toolkit';
import AwarenessCampaignMapReducer from './reducers/awareness_campaigns/map_reducer';
import AddressReducer from './reducers/address_reducer';
import AlgoliaReducer from './reducers/algolia';
import BatchesReducer from './reducers/batches/batch_reducer';
import FilterReducer from './reducers/batches/filtered_batches';
import SortingMapReducer from './reducers/batches/map';
import AwarenessCampaignsReducer from './reducers/awareness_campaigns/list';
import SelectedAwarenessCampaignReducer from './reducers/awareness_campaigns/selected';
import FiltersReducer from './reducers/awareness_campaigns/filters';
import PartnerReducer from './reducers/partner/selected';
import SnacksReducer from './reducers/snacks';
import UserReducer from './reducers/users';
import SortingRulesReducer from './reducers/sorting_rules/sorting_rules';
import RfidsBatchesReducer from './reducers/batches/rfid_batch_reducer';
import CampaignAddressesReducer from './reducers/awareness_campaigns/addresses';
import AddressReportReducer from './reducers/awareness_campaigns/address_report';
import PartnersListReducer from './reducers/partner/list';
import SelectedSurveyTemplateReducer from './reducers/surveyTemplates/selected';
import SurveyTemplatesListReducer from './reducers/surveyTemplates/list';


const store = configureStore({
    reducer: {
        user: UserReducer,
        batch: combineReducers({
            list: BatchesReducer,
            filter: FilterReducer,
            map: SortingMapReducer,
            rfid: RfidsBatchesReducer,
        }),
        address: AddressReducer,
        algolia: AlgoliaReducer,
        awareness_campaign: combineReducers({
            list: AwarenessCampaignsReducer,
            selected: SelectedAwarenessCampaignReducer,
            map: AwarenessCampaignMapReducer,
            addresses: CampaignAddressesReducer,
            address_report: AddressReportReducer,
            filters: FiltersReducer,
        }),
        surveyTemplates: combineReducers({
            list: SurveyTemplatesListReducer,
            selected: SelectedSurveyTemplateReducer,
        }),
        snacks: SnacksReducer,
        sortingRules: SortingRulesReducer,
        partners: combineReducers({
            list: PartnersListReducer,
            selected: PartnerReducer,
        }),
    }
});

export default store;

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export type LoadableContext = {
    loading: boolean;
    error: string | null;
}

export type DataContext<T> = LoadableContext & {
    data: T;
}

export const getStoreState = () => store.getState();